import { DateTime } from "luxon";

/**
 * Messages used when validating start/end. Pass translated strings from the caller.
 */
export type StartEndValidationMessages = {
  startRequired: string;
  endRequired: string;
};

export type ValidateStartEndResult =
  | { valid: true }
  | { valid: false; field: "start" | "end"; message: string };

/**
 * Pure validation for start and end ISO date strings.
 * Returns a result indicating validity or which field failed with which message.
 * Caller is responsible for setting/clearing validation state.
 */
export function validateStartEndForRowLogic(
  startIso: string | undefined,
  endIso: string | undefined,
  messages: StartEndValidationMessages
): ValidateStartEndResult {
  const startEmpty = startIso == null || String(startIso).trim() === "";
  const endEmpty = endIso == null || String(endIso).trim() === "";

  if (startEmpty) {
    return { valid: false, field: "start", message: messages.startRequired };
  }
  if (endEmpty) {
    return { valid: false, field: "end", message: messages.endRequired };
  }

  const startDt = DateTime.fromISO(startIso);
  const endDt = DateTime.fromISO(endIso);

  if (!startDt.isValid) {
    return { valid: false, field: "start", message: messages.startRequired };
  }
  if (!endDt.isValid) {
    return { valid: false, field: "end", message: messages.endRequired };
  }

  return { valid: true };
}
